// extracted by mini-css-extract-plugin
module.exports = {"tag":"companionTag_tag__dK5XI"};